import { put, call } from "redux-saga/effects";
import { VisaCareH4CaseAPI } from "../../utils/api/VisaCareH4CaseAPI";
import {   SAVE_H4FORMS_SUCCESS,SAVE_H4FORMS_FAILED ,  
    UPDATE_H4FORMS_SUCCESS,UPDATE_H4FORMS_FAILED, 
    GET_H4FORMS_SUCCESS,GET_H4FORMS_FAILED ,
    SAVE_H4FORMSTRACKING_SUCCESS,SAVE_H4FORMSTRACKING_FAILED , 
    UPDATE_H4FORMSTRACKING_SUCCESS,UPDATE_H4FORMSTRACKING_FAILED,
    GET_H4FORMSTRACKING_SUCCESS,GET_H4FORMSTRACKING_FAILED,
    GET_H4FORMS539APDF_FAILED , GET_H4FORMS539APDF_SUCCESS
} from "../actions/VisaCareH4Case";
 
export function* createH4PetitionerDetails(request: any) {
  
    try {
           const result=yield call(VisaCareH4CaseAPI.createH4PetitionerDetails, request.input);
         yield put({ 
            type: SAVE_H4FORMS_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_H4FORMS_FAILED, payload: e.message });
    }
}

export function* updateH4PetitionerDetails(request: any) {
   
    try {
           const result=yield call(VisaCareH4CaseAPI.updateH4PetitionerDetails, request.input);
         yield put({ 
            type: UPDATE_H4FORMS_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_H4FORMS_FAILED, payload: e.message });
    }
}
export function*getH4PetitionerDetails (request:any) {
    try {
      
        const { data } = yield call(VisaCareH4CaseAPI.getH4PetitionerDetails,request);
    
      yield put({
          type: GET_H4FORMS_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_H4FORMS_FAILED, payload: e.message });
    }
  }


  
export function* caseflowH4CaseTrackingCreate(request: any) {
  
    try {
           const result=yield call(VisaCareH4CaseAPI.caseflowH4CaseTrackingCreate, request.input);
         yield put({ 
            type: SAVE_H4FORMSTRACKING_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_H4FORMSTRACKING_FAILED, payload: e.message });
    }
}

export function* caseflowH4CaseTrackingUpdate(request: any) {

    try {
           const result=yield call(VisaCareH4CaseAPI.caseflowH4CaseTrackingUpdate, request.input);
         yield put({ 
            type: UPDATE_H4FORMSTRACKING_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_H4FORMSTRACKING_FAILED, payload: e.message });
    }
}
export function*getCaseflowH4CaseTracking (request:any) {
    try {
      
        const { data } = yield call(VisaCareH4CaseAPI.getCaseflowH4CaseTracking,request);
    
      yield put({
          type: GET_H4FORMSTRACKING_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_H4FORMSTRACKING_FAILED, payload: e.message });
    }
  }
  export function* h4FormPdfSubmit(request: any) {
 
    try {
           const { data }=yield call(VisaCareH4CaseAPI.h4FormPdfSubmit, request);
         yield put({ 
            type: GET_H4FORMS539APDF_SUCCESS,     
            payload: data
            
        });
        
    } catch (e) {
        yield put({ type: GET_H4FORMS539APDF_FAILED, payload: e.message });
    }

    
    } 